module.exports = __webpack_public_path__ + "static/img/channel_banner3.4b25399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/channel_banner3.jpg
// module id = sAv3
// module chunks = 0